import {isAnonymized} from "../components/Anonymized.tsx"
import {APhoneField, APhoneFieldDnclStatusEnum} from "../services/types.generated"

type EntityWithPhones = {
  phone_number?: APhoneField
  organization_phone_number?: APhoneField
  additional_phone_number?: APhoneField
}

/** Returns the most severe DNCL status across all phone fields: listed > failed > clear > undefined */
export function getWorstDnclStatus(entity: EntityWithPhones): APhoneFieldDnclStatusEnum | undefined {
  if (isAnonymized(entity)) {
    return undefined
  }

  const statuses = [
    entity.phone_number?.dncl_status,
    entity.organization_phone_number?.dncl_status,
    entity.additional_phone_number?.dncl_status,
  ]

  if (statuses.includes(APhoneFieldDnclStatusEnum.Listed)) {
    return APhoneFieldDnclStatusEnum.Listed
  }
  if (statuses.includes(APhoneFieldDnclStatusEnum.Failed)) {
    return APhoneFieldDnclStatusEnum.Failed
  }
  if (statuses.includes(APhoneFieldDnclStatusEnum.Clear)) {
    return APhoneFieldDnclStatusEnum.Clear
  }
  return undefined
}

export function getDnclColorClass(status: APhoneFieldDnclStatusEnum | null | undefined): string {
  if (status === APhoneFieldDnclStatusEnum.Listed) {
    return "text-cr-red"
  }
  if (status === APhoneFieldDnclStatusEnum.Failed) {
    return "text-cr-yellow"
  }
  return ""
}
